export default "__VITE_ASSET__CaC3SZtL__"